import { NavLink } from "react-router-dom";
import { Home as HomeIcon, Package, Heart, GraduationCap, ClipboardList } from "lucide-react";

const item = ({ isActive }) =>
  `flex flex-col items-center justify-center gap-0.5 flex-1 py-2 text-[10px] font-medium ${
    isActive ? "text-[#0153A3]" : "text-[#6B7280]"
  }`;

export default function BottomNav() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 flex h-16 border-t border-[#E5E7EB] bg-white/95 backdrop-blur-md sm:hidden"
      data-testid="bottom-nav"
    >
      <NavLink to="/" end className={item} data-testid="bottom-nav-home-link">
        <HomeIcon size={20} strokeWidth={2} /> Home
      </NavLink>
      <NavLink to="/prodotti" className={item} data-testid="bottom-nav-prodotti-link">
        <Package size={20} strokeWidth={2} /> Prodotti
      </NavLink>
      <NavLink to="/preferiti" className={item} data-testid="bottom-nav-preferiti-link">
        <Heart size={20} strokeWidth={2} /> Preferiti
      </NavLink>
      <NavLink to="/impara" className={item} data-testid="bottom-nav-impara-link">
        <GraduationCap size={20} strokeWidth={2} /> Impara
      </NavLink>
      <NavLink to="/questionari" className={item} data-testid="bottom-nav-questionari-link">
        <ClipboardList size={20} strokeWidth={2} /> Quest.
      </NavLink>
    </nav>
  );
}
